module.exports = __webpack_public_path__ + "static/media/data_kelas.44f2d6b1.png";